import React from "react";

const SkipToMain = () => {
  return (
    <a href="#main" className="skip-to-main">
      Skip to main content
    </a>
  );
};

export default SkipToMain;
